import i18n from "~/plugins/i18n";

// Impide introducir caracteres no numéricos en un input (handler de keypress). Puro.
export function onlyNumber(event) {
  const charCode = event.which ? event.which : event.keyCode
  if (charCode < 48 || charCode > 57) {
    event.preventDefault()
  }
}

// Al reemplazar una imagen (upload / captura del gantt) el objeto se sustituye entero:
// conservamos details y las leyendas específicas ya definidas por el usuario. Puro.
export function mergeImageKeepingLegends(prev, image) {
  prev = prev || {}
  return {
    details: prev.details || '',
    custom_legends: prev.custom_legends || false,
    legends: prev.legends || [],
    ...image
  }
}

// Rango de fechas (lunes–domingo) de una semana ISO 8601. IMPORTANTE: `year` es el AÑO ISO,
// que puede diferir del calendario cerca de Año Nuevo; por eso se calcula desde el 4 de enero
// (que SIEMPRE cae en la semana ISO 1) y no contando semanas desde el 1 de enero. Puro.
// Devuelve { from, to } como 'yyyy-mm-dd' (listo para <input type="date">), o null si inválido.
export function isoWeekRange(week, year) {
  const w = parseInt(week, 10)
  const y = parseInt(year, 10)
  if (!w || !y || w < 1 || w > 53) return null
  const jan4 = new Date(y, 0, 4)
  const jan4Dow = (jan4.getDay() + 6) % 7 // 0 = lunes … 6 = domingo
  const week1Monday = new Date(y, 0, 4 - jan4Dow)
  const monday = new Date(week1Monday)
  monday.setDate(week1Monday.getDate() + (w - 1) * 7)
  const sunday = new Date(monday)
  sunday.setDate(monday.getDate() + 6)
  return { from: toDateInputValue(monday), to: toDateInputValue(sunday) }
}

// Semana ISO 8601 de una fecha → { week, year(ISO) }. El año ISO puede diferir del calendario
// cerca de Año Nuevo (se calcula por el jueves de la semana). Puro.
export function isoWeekOf(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  const dayNum = (d.getUTCDay() + 6) % 7 // lunes = 0
  d.setUTCDate(d.getUTCDate() - dayNum + 3) // jueves de esta semana
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4))
  const ftDayNum = (firstThursday.getUTCDay() + 6) % 7
  firstThursday.setUTCDate(firstThursday.getUTCDate() - ftDayNum + 3)
  const week = 1 + Math.round((d - firstThursday) / (7 * 24 * 3600 * 1000))
  return { week, year: d.getUTCFullYear() }
}

// Date → 'yyyy-mm-dd' (sin desfases de zona horaria: usa componentes locales). Puro.
export function toDateInputValue(d) {
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return d.getFullYear() + '-' + mm + '-' + dd
}

// ¿El rango 'yyyy-mm-dd' coincide exactamente con la semana ISO (lunes–domingo)? Puro.
export function isIsoWeekComplete(fromStr, toStr, week, year) {
  const r = isoWeekRange(week, year)
  return !!r && r.from === fromStr && r.to === toStr
}

// Redimensiona y comprime una imagen a JPEG (Canvas/FileReader del navegador) manteniendo
// la proporción dentro de `maxSize`. Devuelve un File; si algo falla, el original. Puro
// respecto a Vue (sin estado de componente), por eso vive en el helper y lo comparten los
// modales de subida de imagen (presentación en el .vue).
export function resizeAndCompressImage(file, maxSize, quality) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const ratio = Math.min(maxSize / img.width, maxSize / img.height)
        const width = img.width * ratio
        const height = img.height * ratio
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(
          (blob) => { resolve(blob ? new File([blob], file.name, { type: blob.type }) : file) },
          'image/jpeg',
          quality
        )
      }
      img.src = event.target.result
    }
    reader.onerror = () => resolve(file)
    reader.readAsDataURL(file)
  })
}

function initDataImageExtra(totalImages) {
  return Array.from({ length: totalImages }, (_, i) => ({
    id: i + 1,
    name: i18n.t('image_number', { number: i + 1 }),
    image: null,
    details: '',
    custom_legends: false,
    legends: []
  }))
}

export function mapSection(section) {
  const totalImages = section.numberOfExtraImages || 0;
  const documentType = section.documentType || null;
  return {
    id: section.id,
    name: section.name,
    code: section.code,
    print: section.visible, // esto taves deba venir su propia variable si es necesario modificar aqui
    visible: section.visible,
    disabled: !section.canDisableSection,
    // withWeekly: false, // Esta propiedad no se usa en la configuracion de secciones, por lo que se inicializa como false no se sabe para que es talvez para determinar si se calcula progreso semanal borrar si no se usa mas adelante
    weeklyRange: [], // esta bariable talvez no se usa eliminar si fuera el caso (verificar antes de eliminar)
    weeklyRangeForm: [], // esta bariable talvez no se usa eliminar si fuera el caso (verificar antes de eliminar)
    count: totalImages, // por ahora lo manejamos de esta forma al parecer es la cantidad de imagenes pero hay redundancio con totalImage luego depurar para limpiar
    // fixed: false, // propiedad no usada borrar mas adelante
    with_drawing: documentType === 'drawing',
    drawing_image: '',
    with_activity_document: documentType === 'activity_document',
    activity_image: '',
    with_pictograms: section.withPictograms ?? false, // esta propiedad es una bandera para back si calcula pictogramas, debugear puede que no sea necesario de momento no se hace uso est comentado
    hasAssociatedGroup: section.hasAssociatedGroup ?? false,
    associatedGroupId: section.groupId ?? null,
    is_evacuation_line: false,
    with_status: section.userCanDefineLegend ?? false,
    // Orientación de la página del Gantt en el PDF (solo aplica a la sección GANTT).
    // false = vertical (default), true = horizontal. Valor inicial desde la config;
    // si gantt_user_can_change_orientation está activo el usuario puede cambiarlo al generar.
    gantt_landscape: section.ganttLandscape ?? false,
    // Si es true, la form de generación muestra el selector de orientación; si no, queda oculto.
    gantt_user_can_change_orientation: section.ganttUserCanChangeOrientation ?? false,
    status_oc: [],
    subactivities: [],
    documents: [],
    totalImages,
    images: totalImages ? initDataImageExtra(totalImages) : [],
    // is_evacuation_line: section.isEvacuationLine ?? false, //  es bandera para hucar en el back debuguear si se usa o no realmente esta comentado de momento
  }
}